@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

$code-input-narrow-viewport: 480px;

.verificationCode {
  width: 100% !important;

  > div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  input[type='tel'] {
    @include xxl-sohne;
    text-align: center;
    caret-color: #0b7dd0 !important;
    font-style: normal;
    font-weight: 400;
    line-height: 142%;
    letter-spacing: -0.32px;
    color: var(--neutral-90);
    box-shadow: none;
    border: none;
    border-radius: 6px;
    background-color: var(--light-100);
    margin: 0 7px;
    font-size: 44px;
    line-height: 142%;
    width: 20% !important;
    max-width: 100px;
    min-height: 144px;
    aspect-ratio: 100 / 144;
    box-sizing: border-box;

    &:not(:focus) {
      @include blur(50px);
      background-color: var(--dark-4, rgba(0, 0, 0, 0.04));
      border: none;
      background-color: var(--light-100);
      border: 1px solid var(--dark-8);
      border-radius: 10px;
    }

    caret-color: var(--dark-80) !important;
    border: 1px solid var(--dark-40);
    background-color: #fafafa;
    border-radius: 8px;
    font-size: 48px;
    font-weight: 400;
    line-height: 110%;
    letter-spacing: -0.96px;

    @include for-desktop-only {
      width: 100px !important;
    }

    @include for-phone-only {
      min-height: unset;
      /* Override any inline height from the library so aspect-ratio controls height */
      height: auto !important;
      /* Scale with container: 4 boxes + 8px gaps = 32px; aspect-ratio 100/144 keeps proportion */
      width: calc((100% - 32px) / 4) !important;
      max-width: none;
      margin: 0 4px;
      font-size: clamp(32px, 10vw, 48px);
    }
  }

  /* Below 480px: same scaling so inputs shrink with the viewport-based wrapper */
  @media (max-width: $code-input-narrow-viewport) {
    input[type='tel'] {
      min-height: unset;
      height: auto !important;
      width: calc((100% - 32px) / 4) !important;
      max-width: none;
      margin: 0 4px;
      font-size: clamp(28px, 8vw, 48px);
    }
  }

  input[type='tel']:focus {
    outline: none;
    border: 2px solid #0b7dd0;

    border: 1px solid var(--dark-40);
  }

  input[type='tel']:focus + input {
    border-left: 1px solid var(--neutral-10);
  }
}
